/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { CloudAssetsGlobalForm } from "../../models/ui/cloud-assets-global-form.model";
import { SoftwareAssetsGlobalForm } from "../../models/ui/software-assets-global-form.model";
import { getCurrentWeekRange } from "../../utils/reporting-period";

@Injectable({
	providedIn: "root"
})
export class DashboardStateService {
	private _softwareAssetsGlobalForm = new BehaviorSubject<SoftwareAssetsGlobalForm>({
		applications: [],
		layers: [],
		timePeriod: getCurrentWeekRange(),
		applicationsSelection: { allSelected: true, selectedIds: [], excludedIds: [] },
		layersSelection: { allSelected: true, selectedIds: [], excludedIds: [] }
	});

	private _cloudAssetsGlobalForm = new BehaviorSubject<CloudAssetsGlobalForm>({
		applications: [],
		cloudProviders: [],
		locations: [],
		timePeriod: getCurrentWeekRange()
	});

	public cloudAssetsGlobalForm$ = this._cloudAssetsGlobalForm.asObservable();
	public softwareAssetsGlobalForm$ = this._softwareAssetsGlobalForm.asObservable();

	/**
	 * Updates the global form state for Applications.
	 *
	 * @param form - The new state of the SoftwareAssetsGlobalForm to be set.
	 */
	public setSoftwareAssetsGlobalForm(form: SoftwareAssetsGlobalForm) {
		this._softwareAssetsGlobalForm.next(form);
	}

	/**
	 * Updates the global form state for cloud assets.
	 *
	 * @param form - The new state of the CloudAssetsGlobalForm to be set.
	 */
	public setCloudAssetsGlobalForm(form: CloudAssetsGlobalForm) {
		this._cloudAssetsGlobalForm.next(form);
	}
}
